import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { ContentCut, Menu } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import ThemeToggle from "./ThemeToggle";

export default function MainContainer({
  children,
  isMobile = false,
  onMenuClick,
}: {
  children: React.ReactNode;
  /** When true, show hamburger + compact brand and reserve space above bottom nav */
  isMobile?: boolean;
  onMenuClick?: () => void;
}) {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
      <AppBar position="sticky" color="default" elevation={1}>
        <Toolbar
          variant="dense"
          sx={{
            justifyContent: isMobile ? "space-between" : "flex-end",
            gap: 1,
            minHeight: { xs: 48, md: undefined },
          }}
        >
          {isMobile && (
            <>
              <IconButton
                edge="start"
                color="inherit"
                aria-label={t("common.openMenu")}
                onClick={onMenuClick}
                data-testid="button-sidebar-toggle"
                size="small"
              >
                <Menu />
              </IconButton>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1, minWidth: 0 }}>
                <Box
                  sx={{
                    width: 28,
                    height: 28,
                    borderRadius: 1,
                    bgcolor: "primary.main",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "primary.contrastText",
                    flexShrink: 0,
                  }}
                >
                  <ContentCut sx={{ fontSize: 18 }} />
                </Box>
                <Typography variant="subtitle2" fontWeight={600} noWrap>
                  {t("app.mobileBrand")}
                </Typography>
              </Box>
            </>
          )}
          {!isMobile && <Box sx={{ flex: 1 }} />}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <ThemeToggle />
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="main"
        sx={{
          flex: 1,
          overflow: "auto",
          pb: { xs: "calc(56px + env(safe-area-inset-bottom, 0px))", md: 0 },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
